import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import Topbar from './Topbar';
import { ToastProvider } from './ui';
import { auth } from '../api/tenantApi';
import './theme.css';

export default function AdminLayout() {
  const token2 = sessionStorage.getItem('token');

  // Per the documented Authentication Flow: every endpoint in this
  // controller is [Authorize(Roles = "SuperAdmin")]. Token 2's Role claim
  // only comes back as "SuperAdmin" for the master admin ("waralsadmin")
  // or a tenant user flagged Ismaster — there is no separate userGroupId
  // convention for this. Gate the whole panel on that claim, not a group id.
  const role = token2 ? auth.getRoleFromToken(token2) : null;

  if (!token2 || role !== 'SuperAdmin') {
    return <Navigate to="/login" replace />;
  }

  return (
    <div className="root-scope">
      <ToastProvider>
        <div className="root-shell">
          <Sidebar />
          <Topbar />
          <main className="root-main">
            <Outlet />
          </main>
        </div>
      </ToastProvider>
    </div>
  );
}